import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { Currency } from 'src/app/core/models/models';
import * as SettingsActions from '../actions/settings.actions';
import {
  SettingsState,
  selectClientSettings,
  selectCurrencies,
  selectClientIsAirline
} from '../reducer/settings.reducer';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private store: Store<SettingsState>) {}

  getClientSettings(): Observable<IClientSettings> {
    return this.store.pipe(select(selectClientSettings));
  }

  getClientIsAirline(): Observable<boolean> {
    return this.store.pipe(select(selectClientIsAirline));
  }

  getCurrencies(): Observable<Currency[]> {
    return this.store.pipe(select(selectCurrencies));
  }

  dispatchGetClientSettings(agencyId: string) {
    this.store.dispatch(SettingsActions.LoadClientSettings({ agencyId }));
  }

  dispatchGetCurrencies() {
    this.store.dispatch(SettingsActions.LoadCurrencies());
  }
}
